// extracted by mini-css-extract-plugin
export default {"error-message":"errorMessage_error-message__0CA4X","error-message__warning-icon":"errorMessage_error-message__warning-icon__MALRQ"};